import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import Button from "../../components/ui/button";
import useAuth from "../../hooks/useAuth";

import addObjIcon from "./../../assets/icons/svg/icone-ajouter-un-objet.svg";
import nfcKard from "./../../assets/icons/svg/icone-carte-nfc.svg";
import pendant from "./../../assets/icons/svg/icone-pendentif.svg";
import stand from "./../../assets/icons/svg/icone-presentoir.svg";
import qrCode from "./../../assets/icons/svg/icone-qr-code.svg";

import style from './Home.module.css';
import PageSectionHeader from "../../components/PageSectionHeader";

const Home = () => {
  const {user} = useAuth();
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage(
            { id: "home.documentTitle" },
            { appName: import.meta.env.VITE_APP_NAME }
          )}
        </title>
      </Helmet>
      <div className="h-full flex flex-col">

        <PageSectionHeader className="mb-0">
          <h2 className="text-xl font-normal text-shadow">
            {intl.formatMessage({ id: "home.welcome" }, { lastName: user?.lastName })}
          </h2>
        </PageSectionHeader>

        {/* Center section */}
        <div className="grow grid place-items-center">
          <div className="w-full flex flex-col md:flex-row gap-5 lg:gap-10">
            <div className="px-5 py-5 md:py-11 md:w-1/2 2xl:w-1/3 border border-izygray rounded-lg
              flex flex-col gap-5 md:gap-9 items-center">
              <h4 className="font-bold text-shadow text-xl lg:text-2xl">
                {intl.formatMessage({ id: "home.addObject" })}
              </h4>
              <img
                className="size-8 sm:size-12 md:size-14 lg:size-16"
                src={addObjIcon}
                alt={intl.formatMessage({ id: "home.addObject" })}
              />
              <Button tag="link" to="feature/add" className="px-14" width="fit" size="big">
                {intl.formatMessage({ id: "home.continue" })}
              </Button>
            </div>

            <div className="shrink-0 px-5 py-5 md:py-11 md:w-1/2 2xl:w-1/3 border border-izygray rounded-lg
              flex flex-col gap-5 md:gap-9 items-center">
              <h4 className="font-bold text-shadow text-xl lg:text-2xl">
                {intl.formatMessage({ id: "home.manageActivated" })}
              </h4>
              <div className="flex gap-6">
                <div className={style["shadow-left"]}><img className="size-8 sm:size-12 md:size-14 lg:size-16" src={pendant} /></div>
                <img className="size-8 sm:size-12 md:size-14 lg:size-16" src={stand} />
                <img className="size-8 sm:size-12 md:size-14 lg:size-16" src={nfcKard} />
                <div className={style["shadow-right"]}><img className="size-8 sm:size-12 md:size-14 lg:size-16" src={qrCode} /></div>
              </div>
              <Button tag="link" to="own-objects" className="px-14 z-10" width="fit" size="big">
                {intl.formatMessage({ id: "home.continue" })}
              </Button>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Home;
